<template>
  <div class="review-score-button" aria-hidden="true">
    <div class="icon">
      <review-score-icon :score="scoreOption" />
      <p>
        {{ $t(`customer-dashboard.review-form.review-button-${scoreOption}`) }}
      </p>
    </div>
  </div>
</template>

<script>
import ReviewScoreIcon from "@/components/review/ReviewScoreIcon.vue";

export default {
  name: "ReviewScoreButton",
  components: {
    ReviewScoreIcon
  },
  props: {
    scoreOption: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "~@/scss/components/review-form";
</style>
